export default __webpack_public_path__ + "static/SRF 1100M - Fiche de spécifications et données techniques-cd6f93b83253f1c856a1f78d282f3fd2.pdf";